import React from 'react';
import { withLocalize } from 'react-localize-redux';

import SvgMonitoraNegativni from '../../../img/icons/Monitora-negativni';
import SvgMonitoraNeutralni from '../../../img/icons/Monitora-neutralni';
import SvgMonitoraNeznamy from '../../../img/icons/Monitora-neznamy';
import SvgMonitoraPozitivni from '../../../img/icons/Monitora-pozitivni';
import SvgMonitoraViceznacny from '../../../img/icons/Monitora-viceznacny';

class MonitoraSemaphore extends React.Component {
    render() {
        const sentiment = this.props.sentiment;

        if (sentiment === null || sentiment === undefined)
            return null;

        if (sentiment.toUpperCase() === this.props.translate("Report.Monitora.Sentiment.Neutral").toUpperCase())
            return <SvgMonitoraNeutralni {...this.props} />
        else if (sentiment.toUpperCase() === this.props.translate("Report.Monitora.Sentiment.Negative").toUpperCase())
            return <SvgMonitoraNegativni {...this.props} />
        else if (sentiment.toUpperCase() === this.props.translate("Report.Monitora.Sentiment.Positive").toUpperCase())
            return <SvgMonitoraPozitivni {...this.props} />
        else if (sentiment.toUpperCase() === this.props.translate("Report.Monitora.Sentiment.Ambivalent").toUpperCase())
            return <SvgMonitoraViceznacny {...this.props} />
        else if (sentiment.toUpperCase() === this.props.translate("Report.Monitora.Sentiment.Unknown").toUpperCase())
            return <SvgMonitoraNeznamy {...this.props} />
        return null;
    }
}

export default withLocalize(MonitoraSemaphore);